import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';

export const ModalRoot = styled(Modal)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
}));

export const ModalContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.background.paper,
  boxShadow: '0px 3px 6px #00000024',
  borderRadius: 4,
  overflow: 'auto',
  maxHeight: '100%',
  position: 'relative',
}));

export const ModalBtn = (theme) => ({
  fontSize: theme?.typography?.pxToRem ? theme.typography.pxToRem(14) : 14,
  fontWeight: 500,
  letterSpacing: 0.7,
  marginLeft: 2.5,
});

export const ModalHeader = styled(Box)(() => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '10px 20px',
}));

export const ModalHeaderPadding = styled(Box)(() => ({
  padding: '30px 20px 15px 64px',
}));

export const ModalFooter = styled(Box)(() => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '0px 64px 20px 64px',
}));

export const ModalHeaderTitle = styled(Box)(({ theme }) => ({
  color: theme?.palette?.text?.primary || '#222',
  fontSize: theme?.typography?.pxToRem ? theme.typography.pxToRem(18) : 18,
  display: 'flex',
  alignItems: 'center',
}));

export const ModalBody = styled(Box)(() => ({
  padding: '0px 64px 20px',
}));

export const ModalSm = styled(Box)({
  maxWidth: 400,
  width: '100%',
});

export const ModalMd = styled(Box)({
  maxWidth: 600,
  width: '100%',
});

export const ModalXl = styled(Box)({
  maxWidth: 1046,
  width: '100%',
});

export const ModalLg = styled(Box)({
  width: '100%',
});

export const TooltipSizeSx = (theme) => ({
  fontSize: theme?.typography?.pxToRem ? theme.typography.pxToRem(14) : 14,
  marginLeft: '0.313rem',
});
